/**
 * <s-mobile-bar>: mobile bottom navigation. Sets [data-hidden] while the visitor scrolls down
 * (past the first screen) and removes it when they scroll up or reach the end of the page.
 */
class MobileBar extends HTMLElement {
  #lastY = 0;
  #ticking = false;
  #onScroll = () => {
    if (this.#ticking) return;
    this.#ticking = true;
    requestAnimationFrame(() => {
      const y = window.scrollY;
      const atEnd = window.innerHeight + y >= document.documentElement.scrollHeight - 8;
      const goingDown = y > this.#lastY + 4;
      const goingUp = y < this.#lastY - 4;
      if (goingDown && y > 200 && !atEnd) this.toggleAttribute('data-hidden', true);
      else if (goingUp || atEnd || y <= 200) this.removeAttribute('data-hidden');
      if (goingDown || goingUp) this.#lastY = y;
      this.#ticking = false;
    });
  };

  connectedCallback() {
    this.#lastY = window.scrollY;
    window.addEventListener('scroll', this.#onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#onScroll);
  }
}

if (!customElements.get('s-mobile-bar')) customElements.define('s-mobile-bar', MobileBar);
